/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ServiceRepositoryHelper.ts
 */

import UserService from "./UserService";
import PolicyService from "./PolicyService";
import ClientService from "./ClientService";
import AccessTokenService from "./AccessTokenService";
import DeviceService from "./DeviceService";
import ServiceRepository from "../tools/service/ServiceRepository";
import HTTPService from "../tools/service/HTTPService";
import AuthenticationService from "../tools/service/AuthenticationService";

export default class ServiceRepositoryHelper {

    static inject(svcRepo: ServiceRepository) {
        const httpSvc = svcRepo.resolve(HTTPService.id) as HTTPService;
        const authSvc = svcRepo.resolve(AuthenticationService.id) as AuthenticationService;
        const clientSvc = new ClientService(httpSvc);
        const userSvc = new UserService(httpSvc, authSvc, clientSvc);

        svcRepo.insert(ClientService.id, new ClientService(httpSvc));
        svcRepo.insert(DeviceService.id, new DeviceService(httpSvc));
        svcRepo.insert(UserService.id, userSvc);
        svcRepo.insert(PolicyService.id, new PolicyService(userSvc));
        svcRepo.insert(AccessTokenService.id, new AccessTokenService(httpSvc));

        svcRepo.startServices();
    }
}